import { render, staticRenderFns } from "./AuctionDetails.vue?vue&type=template&id=8d84eec6&scoped=true&"
import script from "./AuctionDetails.vue?vue&type=script&setup=true&lang=js&"
export * from "./AuctionDetails.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./AuctionDetails.vue?vue&type=style&index=0&id=8d84eec6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d84eec6",
  null
  
)

export default component.exports